import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * TagsMore component
 */
export default class More extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'More',
    refs: ['btn', 'container'],
    options: {
      showMore: {
        type: String,
        default: 'Show more',
      },
      showLess: {
        type: String,
        default: 'Show less',
      },
    },
  };

  isClosed = true;

  /**
   * mounted
   */
  mounted() {
    const isInvisible = this.$refs.container.offsetHeight < this.$refs.container.scrollHeight;
    toggleClass(this.$el, 'is-overflowing', isInvisible);
    this.$refs.btn.style.visibility = isInvisible ? 'visible' : 'hidden';
  }

  /**
   * onBtnClick
   */
  onBtnClick() {
    this.isClosed = !this.isClosed;
    toggleClass(this.$refs.container, ['h-[2.55rem]', 'overflow-hidden'], this.isClosed);
    toggleClass(this.$el, 'is-open', !this.isClosed);

    this.$refs.btn.innerHTML = this.isClosed ? this.$options.showMore : this.$options.showLess;
  }
}
